import { Category, Product, Service, ShopProfile } from "@lemmonhq/types";
import { searchProducts } from "@lemmonhq/orders";

export const checkOpeningHours = (shop: ShopProfile) => {
  //  return true;
  if (!shop?.settings) return true;
  const startTimeSetting = shop.settings.find((s) => s.key === "start_time");
  const endTimeSetting = shop.settings.find((s) => s.key === "end_time");

  if (!startTimeSetting || !endTimeSetting) return true;

  const now = new Date();
  const currentTime = now.toLocaleString("en-GB", {
    timeZone: shop.timezone || "Europe/Zurich",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });

  const [currentHour, currentMinute] = currentTime.split(":").map(Number);
  const currentMinutes = currentHour * 60 + currentMinute;

  const [startHour, startMinute] = startTimeSetting.value
    .split(":")
    .map(Number);
  const startMinutes = startHour * 60 + startMinute;

  const [endHour, endMinute] = endTimeSetting.value.split(":").map(Number);
  const endMinutes = endHour * 60 + endMinute;

  // Handle cases where hours span midnight (e.g., 03:00 to 02:59 next day)
  let isOpen: boolean;
  if (endMinutes < startMinutes) {
    // Spanning midnight: open if current time is after start OR before end
    isOpen = currentMinutes >= startMinutes || currentMinutes <= endMinutes;
  } else {
    // Normal case: open if current time is between start and end
    isOpen = currentMinutes >= startMinutes && currentMinutes <= endMinutes;
  }

  console.log({
    startTimeSetting,
    endTimeSetting,
    currentTime,
    currentHour,
    currentMinute,
    currentMinutes,
    startHour,
    startMinute,
    startMinutes,
    endHour,
    endMinute,
    endMinutes,
    isOpen,
    spansAcrossMidnight: endMinutes < startMinutes,
  });

  return true; // Always return true for now to test logging in production
};

export const getLastTableIdKey = (shop: ShopProfile) =>
  `last_table_id_${shop.id}`;

export const getServiceTypeForMethod = (serviceMethod: string) => {
  const serviceTypeMap = {
    "dine-in": "table-service",
    takeaway: "takeaway-service",
    delivery: "delivery-service",
  };
  return serviceTypeMap[serviceMethod as keyof typeof serviceTypeMap];
};

export const extractCategoriesFromServices = (
  services: Service[],
): Category[] => {
  return services.reduce<Category[]>((acc, service) => {
    (service.categories || []).forEach((category) => {
      if (!acc.find((el) => el.id === category.id)) {
        acc.push(category);
      }
    });
    return acc;
  }, []);
};

export const filterProductsByCategories = (
  products: Product[],
  categories: Category[],
  allCategories: Category[],
): Product[] => {
  const categoryIds = new Set(categories.map((c) => c.id));
  return products.filter((product) => {
    return allCategories.some(
      (category) =>
        categoryIds.has(category.id) &&
        category.product_ids?.includes(product.id),
    );
  });
};

export const filterAvailableProducts = (products: Product[]): Product[] => {
  return products.filter((el) => el.status === "available" && !el.deleted_at);
};

export const filterCategoriesByProducts = (
  categories: Category[],
  matchingProductIds: Set<number>,
): Category[] => {
  return categories.filter((category) =>
    category.product_ids?.some((productId) =>
      matchingProductIds.has(productId),
    ),
  );
};

export const filterServicesByCategories = (
  services: Service[],
  matchingCategoryIds: Set<number>,
): Service[] => {
  return services.filter((service) =>
    service.categories?.some((category) =>
      matchingCategoryIds.has(category.id),
    ),
  );
};

export const performMenuSearch = (
  query: string,
  products: Product[],
  categories: Category[],
  services: Service[],
) => {
  if (!query.trim()) {
    return {
      products: [],
      services: [],
      categories: [],
      isSearching: false,
    };
  }

  const searchResults = searchProducts(products, query);
  const matchingProductIds = new Set(searchResults.map((p) => p.id));

  const filteredCategories = filterCategoriesByProducts(
    categories,
    matchingProductIds,
  );
  const matchingCategoryIds = new Set(filteredCategories.map((c) => c.id));

  const filteredServices = filterServicesByCategories(
    services,
    matchingCategoryIds,
  );

  return {
    products: searchResults,
    services: filteredServices,
    categories: filteredCategories,
    isSearching: true,
  };
};
